import { DEFAULT_SIZE_ITEMS } from '../defaults';
import type { SizeFilterStore } from '../Store/store';

export function getSizeDescription(size: SizeFilterStore['size'] | undefined) {
  if (!size) {
    return 'Alla storlekar';
  }

  const matchedSizeItem = DEFAULT_SIZE_ITEMS.find((item) => item.value === size);

  if (matchedSizeItem) {
    return `Storlek ${matchedSizeItem.name} ${matchedSizeItem.subName}`;
  }

  const rangeMatch = size.match(/^(\d*)-?(\d*)$/);
  if (rangeMatch) {
    const [, min, max] = rangeMatch;
    if (max) {
      return `Storlek ${`${min || '0'}-${max} kvm`}`;
    }

    if (min) {
      return `Storlek ${`${min}+ kvm`}`;
    }
  }

  return `Storlek ${size}`;
}
